module.exports = __webpack_public_path__ + "static/SortTheCourt4-20e6485c5ab94ee3dc07e90696fd7b23.webp";